import { MicrosoftClarityPlugin } from './microsoft-clarity-plugin';

export function Plugins() {
    return (
        <>
            <MicrosoftClarityPlugin />
        </>
    );
}
